import { LocalStorageKey, ThemeType } from "@/constants";
import { ThemeControl } from "@/utils/types";

export const themeControl = (): ThemeControl => {
  return {
    setTheme: (theme?: string) => {
      const currentTheme = theme ?? localStorage.getItem(LocalStorageKey.Theme);

      const _theme = !currentTheme
        ? ThemeType.Light
        : currentTheme === ThemeType.Dark
        ? ThemeType.Dark
        : ThemeType.Light;

      localStorage.setItem(LocalStorageKey.Theme, _theme);

      document.documentElement.setAttribute("data-theme", _theme);
    },

    getCurrentTheme: () => localStorage.getItem(LocalStorageKey.Theme),
    isDark: () => themeControl().getCurrentTheme() === ThemeType.Dark,
  };
};
